module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/pretty-check/switch-radio/switch-radio.component.scss
// module id = ./src/app/features/pretty-check/switch-radio/switch-radio.component.scss
// module chunks = main